module.exports = __webpack_public_path__ + "23cfc693edb29695f31702ec03cd886b.png";